import DOMPurify from 'dompurify';

/** The rich-text correction field: a formatted, editable copy of the stored HTML. */
export class TranslationEditHtml {
    static isHtml(value: string): boolean {
        return /<[a-z][^>]*>/i.test(value);
    }

    /** The field's HTML without the editing-only attributes added to protect the placeholders. */
    static read(field: HTMLDivElement): string {
        const copy = field.cloneNode(true) as HTMLDivElement;
        copy.querySelectorAll('[contenteditable]').forEach((element) => element.removeAttribute('contenteditable'));

        return TranslationEditHtml.clean(copy.innerHTML);
    }

    /** The stored value comes from the AI or a correction and bypasses Angular's sanitizer here, so
     * everything that can run code goes; formatting, inline styles and placeholders stay. */
    static clean(html: string): string {
        return DOMPurify.sanitize(html);
    }
}
